function hasValue(value) {
  return value !== undefined && value !== null && value !== "";
}

function normalizeLeadInfo(info) {
  if (!info || Object.keys(info).length === 0) {
    return null;
  }

  const hasSearchType = hasValue(info.search_type);
  const hasSearchUrl = hasValue(info.search_url);

  if (!hasSearchType || !hasSearchUrl) {
    return null;
  }

  return {
    ...info,
    search_type: Number(info.search_type),
    search_url: info.search_url,
  };
}

function mergeLeadInfo(current, incoming) {
  const normalized = normalizeLeadInfo(incoming);
  return normalized || current || {};
}

module.exports = {
  mergeLeadInfo,
  normalizeLeadInfo,
};
